import React, { useState, ChangeEvent } from 'react'
import { Legend, TextArea } from '../../ui/form'

import { tips } from '../locales'
import storage from '../utils/storage'
import './styles.scss'

const IP_COMMENT = 'b3-IP-comment'

const IPPaymentCommet = () => {

  const [ipComment, setIpComment] = useState(storage.B3IPComment.getValue() || '')

  if (storage.IPCheckout.getValue() !== '1') return null

  const handleInputChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    if (event && event?.target) {
      const val = event.target.value
      setIpComment(val)
      val ? storage.B3IPComment.setValue(val) : storage.B3IPComment.removeValue()
    }
  }

  return (window as any)?.B3?.setting?.b2b_url ? (
    <div className="b3-IPPaymentComment-container" >
      <Legend className="inner-IP-label">
        <label htmlFor={ IP_COMMENT }>
          <span>{ tips['b3.IPPaymentComment.label'] }</span>
        </label>
      </Legend>
      <TextArea
        id={ IP_COMMENT }
        name={ IP_COMMENT }
        onChange={handleInputChange}
        value={ ipComment }
        rows={ 6 }
      />
    </div>
  ) : null
}

export default IPPaymentCommet